/* eslint-disable */

import React, { useState } from 'react';
import moment from 'moment';
import ChatMessageAction from './ChatMessageAction';
import { Box, Grid, Stack, Typography } from '@mui/material';
import AttachmentFileDownload from './AttachmentFileDownload';
import ImageViewer from './ImageViewer';
import Reply from './Reply';
import { UserAvatar3 } from 'sections/chat/UserAvatar';

const formatChatTime = (date) => {
	if (!date) return '';
	return moment(String(date)).format('LT');
};

const MessageL = ({ message, date, name, image, file, msgObj, user, isSameUser, userId, privateConversation = false }) => {
	const [contextMenuPosition, setContextMenuPosition] = useState(null);

	const handleContextMenu = (event) => {
		event.preventDefault();
		setContextMenuPosition({ top: event.clientY, left: event.clientX });
	};

	return (
		<Grid item xs={12}>
			<Stack direction="row" alignItems="flex-start">
				<Grid
					container
					justifyContent="flex-start"
					sx={{
						...(isSameUser ? { mt: '3px' } : { mt: '5px' }),
					}}
				>
					<Grid item xs={10} md={9} xl={8}>
						{!isSameUser && (
							<Stack direction="row" justifyContent="flex-start" alignItems="flex-start" spacing={1.25}>
								<UserAvatar3 userId={userId} width={30} height={30} />
								<Typography variant="subtitle1" color="textPrimary" sx={{ overflowWrap: 'anywhere', pt: 0.5, pb: 0.6 }}>
									{name}
								</Typography>
							</Stack>
						)}
						<Stack direction="row" justifyContent="flex-start" spacing={1.25}>
							{privateConversation && <Box sx={{ width: '30px', height: '30px', flexShrink: 0 }}></Box>}
							<Box sx={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'flex-start', maxWidth: '100%' }}>
								<Box
									onContextMenu={handleContextMenu}
									sx={{
										display: 'inline-block',
										wordWrap: 'break-word',
										whiteSpace: 'pre-wrap',
										float: 'left',
										bgcolor: '#DBEFFF',
										color: 'common.black',
										borderRadius: '6px',
										p: '7px 10px',
									}}
								>
									{image && <ImageViewer file={image} />}
									{file && <AttachmentFileDownload attachment={file} />}

									<Stack direction="row" alignItems="center" justifyContent="start">
										<Typography variant="chat" sx={{ overflowWrap: 'anywhere', lineHeight: 1.2 }}>
											{message}
										</Typography>
									</Stack>
								</Box>
								<Box sx={{ mt: 0.25, pl: 0.25, lineHeight: 1, width: '100%' }}>
									<Typography variant="date" component="span" sx={{ color: 'text.secondary' }}>
										{formatChatTime(date)}
									</Typography>
								</Box>
							</Box>
							<ChatMessageAction
								messageObj={msgObj}
								date={date}
								direction="LEFT"
								contextMenuPosition={contextMenuPosition}
								onContextMenuClose={() => setContextMenuPosition(null)}
							/>
						</Stack>
					</Grid>

					<Grid item xs={2} md={3} xl={4} />
				</Grid>
			</Stack>
		</Grid>
	);
};

export default MessageL;

export const DeleteMessageL = ({ date, name, user, isSameUser, userId, privateConversation = false }) => {
	return (
		<Grid item xs={12}>
			<Stack direction="row" alignItems="flex-start">
				<Grid
					container
					justifyContent="flex-start"
					sx={{
						...(isSameUser ? { mt: '3px' } : { mt: '5px' }),
					}}
				>
					<Grid item xs={10} md={9} xl={8}>
						{!isSameUser && (
							<Stack direction="row" justifyContent="flex-start" alignItems="flex-start" spacing={1.25}>
								{/* <ChatUserAvatar user={user} /> */}
								<UserAvatar3 userId={userId} width={30} height={30} />
								<Typography variant="subtitle1" color="textPrimary" sx={{ overflowWrap: 'anywhere', pt: 0.5, pb: 0.6 }}>
									{name}
								</Typography>
							</Stack>
						)}
						<Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={1.25}>
							{privateConversation && <Box sx={{ width: '30px', height: '30px', flexShrink: 0 }}></Box>}
							<Box
								sx={{
									display: 'inline-block',
									wordWrap: 'break-word',
									whiteSpace: 'pre-wrap',
									float: 'left',
									bgcolor: '#9090902b',
									color: '#909090',
									borderRadius: '6px',
									p: '9px 12px 9px 12px',
								}}
							>
								<Stack direction="row" alignItems="center" justifyContent="start">
									<Typography variant="chat" sx={{ overflowWrap: 'anywhere' }}>
										This message was deleted
									</Typography>
									<Typography variant="date" sx={{ visibility: 'hidden', pl: 1 }}>
										{date && moment(date).format('LT')}
									</Typography>
								</Stack>
								<Box
									sx={{
										display: 'inline-block',
										float: 'right',
										lineHeight: '10px',
										marginBottom: '-8px',
										marginRight: '-5px',
										marginTop: '-10px',
									}}
								>
									<Typography variant="date" component="span" align="right">
										{formatChatTime(date)}
									</Typography>
								</Box>
							</Box>
						</Stack>
					</Grid>

					<Grid item xs={2} md={3} xl={4} />
				</Grid>
			</Stack>
		</Grid>
	);
};

export const ReplyMessageL = ({
	message,
	date,
	name,
	reply,
	replyUserName,
	replyMessage,
	msgObj,
	user,
	isSameUser,
	userId,
	privateConversation = false,
}) => {
	const [contextMenuPosition, setContextMenuPosition] = useState(null);

	const handleContextMenu = (event) => {
		event.preventDefault();
		setContextMenuPosition({ top: event.clientY, left: event.clientX });
	};

	return (
		<Grid item xs={12}>
			<Stack direction="row" alignItems="flex-start">
				<Grid
					container
					justifyContent="flex-start"
					sx={{
						...(isSameUser ? { mt: '3px' } : { mt: '5px' }),
					}}
				>
					<Grid item xs={10} md={9} xl={8}>
						{!isSameUser && (
							<Stack direction="row" justifyContent="flex-start" alignItems="flex-start" spacing={1.25}>
								{/* <ChatUserAvatar user={user} /> */}
								<UserAvatar3 userId={userId} width={30} height={30} />
								<Typography variant="subtitle1" color="textPrimary" sx={{ overflowWrap: 'anywhere', pt: 0.5, pb: 0.6 }}>
									{name}
								</Typography>
							</Stack>
						)}
						<Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={1.25}>
							{privateConversation && <Box sx={{ width: '30px', height: '30px', flexShrink: 0 }}></Box>}
							<ChatMessageAction
								messageObj={msgObj}
								date={date}
								direction="LEFT"
								contextMenuPosition={contextMenuPosition}
								onContextMenuClose={() => setContextMenuPosition(null)}
							/>
							<Box sx={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'flex-start', maxWidth: '100%' }}>
								<Box
									onContextMenu={handleContextMenu}
									sx={{
										display: 'inline-block',
										wordWrap: 'break-word',
										whiteSpace: 'pre-wrap',
										float: 'left',
										bgcolor: '#DBEFFF',
										color: 'common.black',
										borderRadius: '6px',
										p: '7px 10px',
									}}
								>
									<Reply replyObj={reply} replyUserName={replyUserName} replyMessage={replyMessage} />
									<Stack direction="row" alignItems="center" justifyContent="start">
										<Typography variant="chat" sx={{ overflowWrap: 'anywhere', lineHeight: 1.2 }}>
											{message}
										</Typography>
									</Stack>
								</Box>
								<Box sx={{ mt: 0.25, pl: 0.25, lineHeight: 1, width: '100%' }}>
									<Typography variant="date" component="span" sx={{ color: 'text.secondary' }}>
										{formatChatTime(date)}
									</Typography>
								</Box>
							</Box>
						</Stack>
					</Grid>

					<Grid item xs={2} md={3} xl={4} />
				</Grid>
			</Stack>
		</Grid>
	);
};
